import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { role: "list" }
const _hoisted_2 = { class: "max-w-3xl mx-auto mb-4 p-4 border border-gray-200 rounded-lg shadow-sm" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "flex-1 pr-2 text-lg text-gray-800 font-semibold" }, " Personal Details ", -1)
const _hoisted_5 = { class: "mt-4 pt-4 border-t border-gray-200" }
const _hoisted_6 = { class: "max-w-3xl mx-auto p-4 border border-gray-200 rounded-lg shadow-sm" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "flex-1 pr-2 text-lg text-gray-800 font-semibold" }, " Contact Information ", -1)
const _hoisted_9 = { class: "mt-4 pt-4 border-t border-gray-200" }
const _hoisted_10 = {
  key: 0,
  class: "max-w-3xl mx-auto mt-4 p-4 border border-gray-200 rounded-lg shadow-sm"
}
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "flex-1 pr-2 text-lg text-gray-800 font-semibold" }, " Security ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_snap_link = _resolveComponent("snap-link")!
  const _component_InputReadOnly = _resolveComponent("InputReadOnly")!
  const _component_PageSection = _resolveComponent("PageSection")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_ProfilePictureUpdateForm = _resolveComponent("ProfilePictureUpdateForm")!
  const _component_snap_button = _resolveComponent("snap-button")!
  const _component_Drawer = _resolveComponent("Drawer")!
  const _component_ProfileUpdateForm = _resolveComponent("ProfileUpdateForm")!
  const _component_EmailUpdateForm = _resolveComponent("EmailUpdateForm")!
  const _component_PhoneUpdateForm = _resolveComponent("PhoneUpdateForm")!
  const _component_PasswordUpdateForm = _resolveComponent("PasswordUpdateForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageContent, {
      title: "My Profile",
      routes: _ctx.routes
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_Avatar, {
          user: _ctx.me,
          icon: "camera-solid",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.drawers.open('updateProfilePictureDialog')))
        }, null, 8, ["user"])
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_BackButton)
      ]),
      default: _withCtx(() => [
        (_ctx.missingAttributes.length > 0)
          ? (_openBlock(), _createBlock(_component_Alert, {
              type: "warning",
              key: _ctx.missingAttributes.length
            }, {
              description: _withCtx(() => [
                _createElementVNode("ul", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.missingAttributes, (attr) => {
                    return (_openBlock(), _createElementBlock("li", { key: attr }, _toDisplayString(_ctx.attrName(attr)), 1))
                  }), 128))
                ])
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Please fill in the following fields to continue: ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_PageSection, null, {
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_snap_link, {
                  icon: "pencil-solid",
                  text: "Edit",
                  size: "sm",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.drawers.open('updateProfileDialog')))
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_InputReadOnly, {
                  label: "Name",
                  value: _ctx.me?.fullName,
                  inline: ""
                }, null, 8, ["value"]),
                _createVNode(_component_InputReadOnly, {
                  label: "Language",
                  value: _ctx.languageName,
                  inline: ""
                }, null, 8, ["value"]),
                (_ctx.isHsGradYearVisible && _ctx.me?.hsGradYear)
                  ? (_openBlock(), _createBlock(_component_InputReadOnly, {
                      key: 0,
                      label: "High School Graduation Year",
                      value: _ctx.me?.hsGradYear,
                      inline: ""
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("section", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_snap_link, {
                  icon: "pencil-solid",
                  text: "Edit",
                  size: "sm",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.drawers.open('updateContactsDialog')))
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_InputReadOnly, {
                  label: "Email",
                  value: _ctx.me?.email,
                  inline: ""
                }, null, 8, ["value"]),
                _createVNode(_component_InputReadOnly, {
                  label: "Phone",
                  value: _ctx.me?.phoneNumber,
                  inline: ""
                }, null, 8, ["value"])
              ])
            ]),
            (_ctx.canEditPassword)
              ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_snap_link, {
                      text: "Update",
                      size: "sm",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.drawers.open('updatePasswordDialog')))
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["routes"]),
    _createVNode(_component_Drawer, {
      ref: "updateProfilePictureDialog",
      title: "Update Profile Picture"
    }, {
      default: _withCtx(({ close, state }) => [
        _createVNode(_component_ProfilePictureUpdateForm, {
          ref: "updateProfilePictureForm",
          "onForm:success": close,
          "onState:normal": ($event: any) => (state.set('NORMAL')),
          "onState:submitting": ($event: any) => (state.set('SUBMITTING'))
        }, null, 8, ["onForm:success", "onState:normal", "onState:submitting"])
      ]),
      actions: _withCtx(({ close, state }) => [
        _createVNode(_component_snap_button, {
          "button-type": "button",
          size: "sm",
          variant: "tertiary",
          onClick: close,
          disabled: state.is('SUBMITTING'),
          "full-width": ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel ")
          ]),
          _: 2
        }, 1032, ["onClick", "disabled"]),
        _createVNode(_component_snap_button, {
          "button-type": "button",
          size: "sm",
          variant: "primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (
          (_ctx.$refs.updateProfilePictureForm as ProfilePictureUpdateForm)?.update()
        )),
          class: "inline-block",
          disabled: state.is('SUBMITTING'),
          "full-width": ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Save ")
          ]),
          _: 2
        }, 1032, ["disabled"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Drawer, {
      ref: "updateProfileDialog",
      title: "Edit Personal Details"
    }, {
      default: _withCtx(({ close, state }) => [
        _createVNode(_component_ProfileUpdateForm, {
          ref: "updateProfileForm",
          "onForm:success": close,
          "onState:normal": ($event: any) => (state.set('NORMAL')),
          "onState:submitting": ($event: any) => (state.set('SUBMITTING'))
        }, null, 8, ["onForm:success", "onState:normal", "onState:submitting"])
      ]),
      actions: _withCtx(({ close, state }) => [
        _createVNode(_component_snap_button, {
          "button-type": "button",
          size: "sm",
          variant: "tertiary",
          onClick: close,
          disabled: state.is('SUBMITTING'),
          "full-width": ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel ")
          ]),
          _: 2
        }, 1032, ["onClick", "disabled"]),
        _createVNode(_component_snap_button, {
          "button-type": "button",
          size: "sm",
          variant: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ((_ctx.$refs.updateProfileForm as ProfileUpdateForm)?.update())),
          class: "inline-block",
          disabled: state.is('SUBMITTING'),
          "full-width": ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Save ")
          ]),
          _: 2
        }, 1032, ["disabled"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Drawer, {
      ref: "updateContactsDialog",
      title: "Edit Contact Information"
    }, {
      actions: _withCtx(({ close }) => [
        _createVNode(_component_snap_button, {
          "button-type": "button",
          size: "sm",
          variant: "tertiary",
          onClick: close,
          "full-width": ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel ")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      default: _withCtx(() => [
        (_ctx.canEditEmail)
          ? (_openBlock(), _createBlock(_component_EmailUpdateForm, {
              key: 0,
              class: "mb-4 border-b border-gray-200"
            }))
          : _createCommentVNode("", true),
        (!_ctx.canEditEmail)
          ? (_openBlock(), _createBlock(_component_InputReadOnly, {
              key: 1,
              class: "my-4 pb-4 border-b border-gray-200",
              label: "Email",
              value: _ctx.me?.email,
              inline: ""
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        _createVNode(_component_PhoneUpdateForm, { class: "my-4" })
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Drawer, {
      ref: "updatePasswordDialog",
      title: "Update Password"
    }, {
      default: _withCtx(({ close, state }) => [
        _createVNode(_component_PasswordUpdateForm, {
          ref: "updatePasswordForm",
          "onForm:success": close,
          "onState:normal": ($event: any) => (state.set('NORMAL')),
          "onState:submitting": ($event: any) => (state.set('SUBMITTING'))
        }, null, 8, ["onForm:success", "onState:normal", "onState:submitting"])
      ]),
      actions: _withCtx(({ close, state }) => [
        _createVNode(_component_snap_button, {
          "button-type": "button",
          size: "sm",
          variant: "tertiary",
          onClick: close,
          disabled: state.is('SUBMITTING'),
          "full-width": ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel ")
          ]),
          _: 2
        }, 1032, ["onClick", "disabled"]),
        _createVNode(_component_snap_button, {
          "button-type": "button",
          size: "sm",
          variant: "primary",
          onClick: _cache[6] || (_cache[6] = ($event: any) => ((_ctx.$refs.updatePasswordForm as PasswordUpdateForm)?.update())),
          class: "inline-block",
          disabled: state.is('SUBMITTING'),
          "full-width": ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Save ")
          ]),
          _: 2
        }, 1032, ["disabled"])
      ]),
      _: 1
    }, 512)
  ], 64))
}